<template>
    <header
        id="site-header" class="site-header"
        :class="{ 'open' : isOpen }"
    >
        <div class="content-max-width flex">

            <a href="/home" class="logo">
                <!-- <img src="/images/logo.png" alt="Gree" /> -->
                <img src="/images/new-logo.png" class="heat" alt="Gree" />
            </a>

            <span class="background" @click="closeMenu()"></span>
            <nav @mouseleave="removeSelected()">
                <ul class="top">
                    <li
                        v-for="(link, index) of menu"
                        :key="index"
                        :class="{ 'has-children' : link.children && link.children.length }"
                    >
                        <a
                            class="desktop"
                            v-if="link.mega_menu"
                            @mouseover="openMegaMenu(link)"
                            :class="{ 'selected' : isMegaOpen }"
                        >
                            {{ link.title }}
                        </a>

                        <a
                            class="desktop"
                            v-if="link.children && link.children.length"
                            @click="toggleChildMenu(link)"
                            @mouseover="closeMegaMenu(link)"
                            :href="link.url"
                            :class="{ 'selected' : isChildOpen }"
                        >
                            {{ link.title }}
                        </a>


                        <a
                            class="mobile"
                            v-if="link.mega_menu"
                            @click="toggleMegaMenu(link)"
                            :class="{ 'selected' : isMegaOpen }"
                            :href="link.url"
                        >
                            {{ link.title }}
                        </a>



                        <a
                            class="mobile"
                            v-else-if="link.children && link.children.length"
                            @click="toggleChildMenu(link)"

                        >

                            {{ link.title }}
                        </a>
                        <a
                            v-else
                            :href="link.url"
                            @mouseover="removeSelected()"
                        >
                            {{ link.title }}
                        </a>

                        <ul
                            v-if="link.children && link.children.length"
                            class="child-ul desktop"
                        >
                            <li v-for="(child, index) of link.children" :key="index">
                                <a :href="child.url" v-if="child.title == 'Error Code Search' || child.title == 'Gree Academy'" target="_blank">{{ child.title }}</a>
                                <a :href="child.url" v-else>{{ child.title }}</a>
                            </li>
                        </ul>

                        <ul
                            v-if="link.children && link.children.length"
                            v-show="isChildOpen"
                            class="child-ul mobile"
                        >
                            <li v-for="(child, index) of link.children" :key="index">
                                <a :href="child.url" v-if="child.title == 'Error Code Search'" target="_blank">{{ child.title }}</a>
                                <a :href="child.url" v-else>{{ child.title }}</a>
                            </li>
                        </ul>

                    </li>
                    <li v-if="logged_in">
                        <app-logout-link :csrf="csrf"></app-logout-link>
                    </li>
                </ul>

                <div class="nav-bottom mobile">
                    <a href="/where-to-buy" class="button">WHERE TO BUY</a>
                    <a  :href="'tel:' + phone.replace(/ /g, '')" class="phone">{{ phone }}</a><br>
                    <a :href="ultimate_degrees" class="link" target="_blank">ULTIMATE DEGREES <img src="/images/icon-target.svg" alt="Gree Online"></a>
                </div>
            </nav>

            <div class="right-info flex align-center ">
                <div class="more desktop" v-if="(phone != null)">
                    <a  :href="'tel:' + phone.replace(/ /g, '')" class="phone">{{ phone }}</a>
                    <a :href="ultimate_degrees" class="link" target="_blank">ULTIMATE DEGREES <img src="/images/icon-target.svg" alt="Gree Online"></a>
                </div>

                <a href="/where-to-buy" class="button desktop">WHERE TO BUY</a>

                <button
                    class="search"
                    @click="toggleSearch()"
                >
                    <span class="icon icon-search2"></span>
                </button>
            </div>

            <button class="hamburger mobile" @click="toggleMenu">
                <span></span>
                <span></span>
                <span></span>
            </button>

        </div>

        <div
            class="mega-menu desktop"
            :class="{ 'active' : isMegaOpen }"
            @mouseleave="closeMegaMenu()"
        >
            <div class="content-max-width flex flex-between">

                <div
                    v-for="(cat, index) of mega_menu" :key="index"
                    class="category flex"
                >
                    <a
                        :href="cat.url"
                        class="image"
                    >
                        <img :src="cat.image" :alt="cat.title">
                    </a>
                    <div class="links">
                        <h2>{{ cat.title }}</h2>
                        <a
                            v-for="link of cat.children"
                            :href="link.url"
                        >
                            {{ link.title }}
                        </a>
                        <a :href="cat.url" class="orange">View All</a>
                    </div>
                </div>

            </div>
        </div>

        <div
            class="search-area"
            :class="{ 'active' : isSearchOpen }"
        >
            <div class="content-max-width flex flex-between">

                <div class="select">
                    <select v-model="category" name="category" id="">
                        <option value="" selected>ALL Categories</option>
                        <option :value="link.title" v-for="(link, index) of categories" :key="index">{{link.title}}</option>

                    </select>
                </div>
                <input name="keyword" v-model="keyword" type="text" placeholder="Search Gree" @keyup.enter="search()">
                <input name="category1"  type="hidden" >
                <button type="submit" v-on:click="search()" @keyup.enter="search()" class="button orange">
                    <span v-on:click="search()" @keyup.enter="search()"  class="mobile">SEARCH </span><span class="icon icon-search2" @keyup.enter="search()" v-on:click="search()"></span>
                </button>

            </div>
        </div>

    </header>
</template>

<script>
export default {
    props: [
        'csrf', 'menu', 'mega_menu', 'logged_in', 'categories', 'ultimate_degrees', 'phone'
    ],
    data() {
        return {
            isOpen: false,
            isMegaOpen: false,
            isChildOpen: false,
            isSearchOpen: false,
            keyword: '',
            category: '',
        };
    },
    methods: {

        toggleMenu() {
            this.isOpen = !this.isOpen
            this.$parent.fixed = this.isOpen
        },

        toggleChildMenu(link) {
            this.isChildOpen = !this.isChildOpen
            // console.log(link, this.isChildOpen)
        },

        toggleSearch() {
            this.isSearchOpen = !this.isSearchOpen
        },

        closeMenu() {
            this.isOpen = false
            this.$parent.fixed = false
        },

        removeSelected() {
            this.isChildOpen = false
        },

        closeMegaMenu(link) {
            this.isMegaOpen = false
            if (typeof link === 'object' && link.url && link.url == '/customer-support') {
                this.toggleChildMenu(link)
            }
        },

        openMegaMenu() {
            this.isMegaOpen = true
            this.isChildOpen = false
        },

        toggleMegaMenu(link) {
            console.log(link)
            this.isMegaOpen = !this.isMegaOpen
        },
        search() {
            console.log(this.category)
            if (this.category.length > 0) {
                window.location = '/products/search?keyword=' + this.keyword + '&category=' + this.category
            } else {
                window.location = '/products/search/' + this.keyword
            }
        },

        logout() {
            window.axios.post('/logout', {token: this.csrf})
                .then(response => {
                    window.location.href = '/'
                })
                .catch(error => {

                })
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue